import {
    call,
} from "redux-saga/effects";
import toast from "../../components/toast";

export default function* notify(style, message) {
    yield call(toast, ...[message, style]);
}
